"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useResetSystemSettingsMutation = exports.useUpdateSystemSettingsMutation = exports.useGetSystemSettingsQuery = exports.systemSettingsApi = void 0;
var react_1 = require("@reduxjs/toolkit/query/react");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
exports.systemSettingsApi = (0, react_1.createApi)({
    reducerPath: "systemSettingsApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.API_URL),
    tagTypes: ["SystemSettings"],
    endpoints: function (builder) { return ({
        getSystemSettings: builder.query({
            query: function () { return "/v1/system-settings"; },
            providesTags: ["SystemSettings"],
        }),
        updateSystemSettings: builder.mutation({
            query: function (body) { return ({
                url: "/v1/system-settings",
                method: "PUT",
                body: body,
            }); },
            invalidatesTags: ["SystemSettings"],
        }),
        resetSystemSettings: builder.mutation({
            query: function () { return ({
                url: "/v1/system-settings/reset",
                method: "POST",
            }); },
            invalidatesTags: ["SystemSettings"],
        }),
    }); },
});
exports.useGetSystemSettingsQuery = exports.systemSettingsApi.useGetSystemSettingsQuery, exports.useUpdateSystemSettingsMutation = exports.systemSettingsApi.useUpdateSystemSettingsMutation, exports.useResetSystemSettingsMutation = exports.systemSettingsApi.useResetSystemSettingsMutation;
